var allProds = '';
//allprdts();

$(document).ready(function() {
  
  setTimeout(function() {
      $('#offer10Modal').modal();
  }, 2000);

  function showLanguage(languageId) {
     $('[id^="menual"]').addClass('hidden');
      // Show the selected language element
      $(languageId).removeClass('hidden');
     
    }
  // Click event for English
    $('#english').click(function() {
      showLanguage('#menual-english');
    });

    // Click event for Arabic
    $('#arabic').click(function() {
      showLanguage('#menual-arabic');
    });
  
   function handleQuantityIncrement(qty) {
      var input = $('#'+qty+'-quantity');
      var result = parseFloat(input.val());
     var input_v1 = parseFloat($('#v1-quantity').val());
     var input_v2 = parseFloat($('#v2-quantity').val());
    if (input_v1 > 0 || input_v2  > 0){
         $('.add-to-cart-button').removeAttr('disabled');
    }else  if (input.val() > 0) {
        $('.add-to-cart-button').removeAttr('disabled');
    }else{
           $('.add-to-cart-button').attr('disabled', 'disabled');
    }
     
    }

  $('#v1-quantity').on('keyup', function() {
      handleQuantityIncrement('v1');
    });

   $('#v2-quantity').on('keyup', function() {
      handleQuantityIncrement('v2');
    });
  
  //console.log(localStorage.getItem('resUrl'));
  if(localStorage.getItem('resUrl') != null) {
    var refer = localStorage.getItem('resUrl');
    var wrongpass = refer.includes("/account/reset");

    if (wrongpass) {
      localStorage.removeItem('resUrl');
      $('.log-s1').attr('style','display:none;');
      $('.resetp-s1').attr('style','display:block;');
      addUserInfo();

      $('#loginModal').modal('toggle');
    }
  }
  
  var searchImg = "//taqeef.ma/cdn/shop/t/6/assets/search-icon.svg?v=2736892629889974361789131536";
  var closeImg = "https://cdn.shopify.com/s/files/1/0528/7290/4876/files/search-close-icon.svg?v=1624866533";
  var isSearchVisible = false;
  
  /* Search box */
  $(".taqeef-header-search-toggle").on('click', function() {
    if(!isSearchVisible)
    {
      $('.taqeef-header-search-wrapper').addClass('search-active');
      $('.taqeef-header-search-toggle').attr('src', closeImg);
      $('.taqeef-header-search-toggle').attr('style','height:20px; margin-top:2px;');
      isSearchVisible = true;
    }
    else
    {
      $('.taqeef-header-search-toggle').attr('src', searchImg);
      $('.taqeef-header-search-wrapper').removeClass('search-active');
      $('.taqeef-header-search-toggle').attr('style','');
      
      $('.taqeef-header-search-input').val(""); 
      $('.search-results').removeClass('search-results-show');
      $('.main-content').removeClass('nav-search');
      isSearchVisible = false;
    }
  });
  
  /*$(document).on('click', function(e) {
    if($(event.target).hasClass('taqeef-header-search-input'))
    { }
    else if ( !$(event.target).hasClass('taqeef-header-search-wrapper') && 
             !$(event.target).hasClass('taqeef-header-search-toggle') && 
             !$(event.target).hasClass('search-item') && 
             !$(event.target).hasClass('slick-track') && 
             $('.taqeef-header-search-wrapper').hasClass('search-active')) 
    {
      //console.log($(event.target).attr('class') + 'clicked outside');
      $('.taqeef-header-search-toggle').attr('src', searchImg);
      $('.taqeef-header-search-wrapper').removeClass('search-active');
      $('.taqeef-header-search-toggle').attr('style','');
      
      $('.taqeef-header-search-input').val("");
      $('.search-results').removeClass('search-results-show');
      $('.main-content').removeClass('nav-search');
      isSearchVisible = false;
    }
  });*/
  
  $( ".taqeef-header-search-form" ).submit(function( event ) {
    event.preventDefault();
    var searchGrid = document.getElementById('search-res');
    var query = $('.taqeef-header-search-input').val().toLowerCase();
    
    searchGrid.innerHTML = '';
    var baseUrl = "https://taqeef-iraq.myshopify.com/";
    
    if(query != '')
    {
      $.ajax({
        type: "GET",
        //url: baseUrl + '/admin/api/2021-04/products.json',
        url: 'https://tech.taqeef.com/taq/taq-getproducts.php?type=products&baseurl=' + baseUrl + '',
        success: function(data, textStatus, xhr)
        {
          //console.log(data);
          data = JSON.parse(data);
          if(data != null && data.products.length > 0)
          {
            var productsFound = [];
            data.products.forEach(function(item) {
              //console.log(item.tags);
              //if (query.indexOf("split") >= 0){ console.log('yes'); }
              if(item.title.toLowerCase().includes(query) || item.vendor.toLowerCase().includes(query) || item.variants[0].sku.toLowerCase().includes(query) || item.tags.toLowerCase().includes(query))
              { 
                //console.log(item);
                productsFound.push(item);
              }
            });
            
            if(productsFound != null && productsFound.length > 0)
            {
              getMetaFields(productsFound, query, searchGrid, baseUrl);
            }
            else
            {
              var errtext = '<div class="search-no-result">Sorry! There are no products that match your search.</div>';
              searchGrid.insertAdjacentHTML('beforeend', errtext);

              $('.search-results').addClass('search-results-show');
              $('.main-content').addClass('nav-search');
            }
          }
        }
      });
    }
    
    //event.preventDefault();
  });
  
  function getMetaFields(data, query, searchGrid, baseUrl)
  {
    data.forEach(function(item) {
      var metaurl = 'https://tech.taqeef.com/taq/taq-getproducts.php?type=metadata&baseurl=' + baseUrl + '&pid=' + item.id + '';
      
      $.ajax({
          type: "GET",
          //url: baseUrl + '/admin/api/2021-04/products/' + item.id + '/metafields.json',
          url: metaurl,
          success: function(metadata, textStatus, xhr)
          {
            //console.log(metadata);
            metadata = JSON.parse(metadata);
            var rating = '';
            var comp = '';
            metadata.metafields.forEach(function(metaobj) {
              if(metaobj.key == 'ac-rating') { rating = metaobj.value; }
              if(metaobj.key == 'ac-compressor') { comp = metaobj.value; }
            }); 

            var proditem = '';
            proditem += '<a href="' + baseUrl + '/products/' + item.handle + '">';
            proditem += '<div class="search-item">';
            proditem +=   '<img src="' + item.image.src + '" alt="' + (item.title ? item.title.replace(/"/g, '&quot;') : 'Product Image') + '">';
            proditem +=   '<div class="search-item-content">';
            proditem +=     '<h2>' + item.title + '</h2>';
            proditem +=     '<div class="inner">';
            proditem +=     '<p class="ac-info"> الضاغط ' + comp + '</p>';        
            var price = item.variants[0].price;
            
            proditem +=     '<p class="msearch-price">' + Math.round(price).toLocaleString('en-IQ') + ' د.ع</p>';
            
            if(item.variants[0].inventory_quantity <= 0)
            {
              proditem +=     '<p class="stock-status-list-item">نفذ</p>';
            }
            else if(item.variants[0].inventory_quantity <= 4)
            {
            var  proditemtest  =     '<p class="stock-status-list-item">Only ' + item.variants[0].inventory_quantity + ' units left</p>';
            }
            
            proditem +=     '</div>';
            proditem +=   '</div>';
            proditem += '</div>';
            proditem += '</a>';

            searchGrid.insertAdjacentHTML('beforeend', proditem);
          }
      });
    });
    
    $('.search-results').addClass('search-results-show');
    $('.main-content').addClass('nav-search');
  }
  
  
  
  
  
  //Mobile Search
  $( ".header-search-form-mobile" ).submit(function( event ) {
    event.preventDefault();
    var searchGrid = document.getElementById('msearch-res');
    var query = $('.mobile-header-search-input').val().toLowerCase();
    
    searchGrid.innerHTML = '';
    var baseUrl = "https://taqeef-iraq.myshopify.com/";
    
    if(query != '')
    {
      $.ajax({
        type: "GET",
        //url: baseUrl + '/admin/api/2021-04/products.json',
        url: 'https://tech.taqeef.com/taq/taq-getproducts.php?type=products&baseurl=' + baseUrl + '',
        success: function(data, textStatus, xhr)
        {
          //console.log(data);
          data = JSON.parse(data);
          if(data != null && data.products.length > 0)
          {
            var productsFound = [];
            data.products.forEach(function(item) {
              if(item.title.toLowerCase().includes(query) || item.vendor.toLowerCase().includes(query) || item.variants[0].sku.toLowerCase().includes(query) || item.tags.toLowerCase().includes(query))
              { 
                //console.log(item);
                productsFound.push(item);
              }
            });
            
            if(productsFound != null && productsFound.length > 0)
            {
              getMetaFieldsMob(productsFound, query, searchGrid, baseUrl);
            }
            else
            {
              var errtext = '<div class="search-no-result">Sorry! There are no products that match your search.</div>';
              searchGrid.insertAdjacentHTML('beforeend', errtext);

              $('.search-results').addClass('search-results-show');
              $('.main-content').addClass('nav-search');
            }
          }
        }
      });
    }
    
    //event.preventDefault();
  });
  
  function getMetaFieldsMob(data, query, searchGrid, baseUrl)
  { 
    data.forEach(function(item) {
      var metaurl = 'https://tech.taqeef.com/taq/taq-getproducts.php?type=metadata&baseurl=' + baseUrl + '&pid=' + item.id + '';
      
      $.ajax({
          type: "GET",
          //url: baseUrl + '/admin/api/2021-04/products/' + item.id + '/metafields.json',
          url: metaurl,
          success: function(metadata, textStatus, xhr)
          {
            //console.log(metadata);
            metadata = JSON.parse(metadata);
            var rating = '';
            var comp = '';
            metadata.metafields.forEach(function(metaobj) {
              if(metaobj.key == 'ac-rating') { rating = metaobj.value; }
              if(metaobj.key == 'ac-compressor') { comp = metaobj.value; }
            });

            var proditem = '';
            proditem += '<a href="' + baseUrl + '/products/' + item.handle + '">';
            proditem += '<div class="search-item mobile">';
            proditem +=   '<img src="' + item.image.src + '" alt="' + (item.title ? item.title.replace(/"/g, '&quot;') : 'Product Image') + '">';
            proditem +=   '<div class="search-item-content">';
            proditem +=     '<h2 style="font-size:15px; font-family: \'Noto Kufi Arabic\', \'Roboto\'; font-weight: bold; color:#606C74;">' + item.title + '</h2>';
            proditem +=     '<div style="padding-top:5px;">';
            proditem +=       '<p style="font: normal normal normal 14px/18px \'Noto Kufi Arabic\', \'Roboto\'; letter-spacing: 0px; color: #606C7480; padding: 0;">' + comp + ' compressor</p>';
      
            if(item.variants[0].inventory_quantity <= 0)
            {
              proditem +=     '<p class="stock-status-list-item msearch">نفذ</p>';
            }
            else if(item.variants[0].inventory_quantity <= 4)
            {
            var  proditemtest  =     '<p class="stock-status-list-item msearch">Only ' + item.variants[0].inventory_quantity + ' units left</p>';
            }
             var price = item.variants[0].price;            
            proditem +=     '<p class="msearch-price">' + Math.round(price).toLocaleString('en-IQ') + ' د.ع</p>';           
      
            proditem +=     '</div>';
            proditem +=   '</div>';
            proditem += '</div>';
            proditem += '</a>';

            searchGrid.insertAdjacentHTML('beforeend', proditem);
          }
      });
    });
    
    //$('.search-results').addClass('search-results-show');
  }
  
  
  
  
  
  /* Trending Products Slider */
  /* $('.trending-card-row').slick({
    infinite: false,
    slidesToScroll: 1,
    /*slidesToShow:4,
    variableWidth: true,
    dots: false,
    prevArrow: false,
    nextArrow: false
  }); */
  
  /* Retail Partners Slider */
  $('.retail-partner-slider').slick({
    infinite: false,
    slidesToScroll: 1,
    slidesToShow:7,
    dots: false,
    prevArrow: false,
    nextArrow: false
  });
  
  /* Taqeef Testamonials */
  $('.testamonials-slider').slick({
    infinite: true,
    slidesToScroll: 1,
    slidesToShow:1,
    dots: true,
    nextArrow: "<button class='slick-next slick-arrow' aria-label='Next' type='button' style='' aria-disabled='false'><img style='display: block; position: relative; height:100%; width:100%; object-fit:cover; min-width: 24px;' src='https://cdn.shopify.com/s/files/1/0528/7290/4876/files/testamonial-arrow-right.svg?v=1624622026' alt='Next' aria-hidden='true' /></i></button>",
    prevArrow: "<button class='slick-prev slick-arrow slick-disabled' aria-label='Previous' type='button' aria-disabled='true' style=''><img style='display: block; position: relative; height:100%; width:100%; object-fit:cover; min-width: 24px;' src='https://cdn.shopify.com/s/files/1/0528/7290/4876/files/testamonial-arrow-left.svg?v=1624621667' alt='Previous' aria-hidden='true' /></button>"
  });
  
  
  /* Search results Slider */
  $('.search-results').slick({
    infinite: false,
    slidesToScroll: 1,
    /*slidesToShow:4,*/
    variableWidth: true,
    dots: false,
    prevArrow: false,
    nextArrow: false
  });
  
  
  
  
  /* Language select dropdown */
  $('.hiddenn p').click(function() {
    $(this).closest('.language-select').find('.input').text($(this).text());
    $(this).closest('.language-select').find('input').val($(this).attr('value'));
    $(this).closest('.language-select').trigger("change");
    
    $(this).closest('.sort-select').find('.input').text($(this).text());
    $(this).closest('.sort-select').find('input').val($(this).attr('value'));
    $(this).closest('.sort-select').trigger("change");
  });
  
  $('.l-link').click(function(){
    $(".l-link").find("span").toggleClass("active", false);
    $(this).find("span").toggleClass("active", true);
  });
  
  
  
  
  //On Checkout
  $('#scart').on('submit', function(e) {
    
    $('#termsErr').html('');
    if(!$('#termsAgree').is(":checked")) {
      e.preventDefault();
      $('#termsErr').html('يرجى التأكد من الموافقة على شروط الموقع.');
    }
    else
    {
      if($('.header-account .header-actions-list-item').attr('href') === undefined) {
        e.preventDefault();
        $('#loginModal').modal('toggle');
      }
    }
    
  });
  
  //Checkout after adding product
  $('body').on('click', '.apCheckout', function () {
    if($('.header-account .header-actions-list-item').attr('href') === undefined) {
      $('#loginModal').modal('toggle');
    }
    else {
      window.location.href = '/checkout';
    }
  });
  
  
  
  
  
  //Check passwords register
  var regError = 'https://cdn.shopify.com/s/files/1/0528/7290/4876/files/reg-error-icon.svg?v=1625480693';
  var regValid = 'https://cdn.shopify.com/s/files/1/0528/7290/4876/files/reg-valid-icon.svg?v=1625480692';
  
  $('#customer_password, #repeat_password').on('keyup', function () {
    if ($('#customer_password').val() == $('#repeat_password').val()) {
      if($('#create_customer .rep-pw').hasClass('error')) {
        $('#create_customer .rep-pw').removeClass('error');
        $('#create_customer .reg-pw img').attr('src',regValid);
        $('#create_customer .rep-pw img').attr('src',regValid);
      }
    } 
    else {
      if(!$('#create_customer .rep-pw').hasClass('error')) {
        $('#create_customer .rep-pw').addClass('error');
        $('#create_customer .rep-pw img').attr('src',regError);
        $('#create_customer .reg-pw img').attr('src','');
      }
    }
  });
  
  $('#res_customer_password, #res_repeat_password').on('keyup', function () {
    if ($('#res_customer_password').val() == $('#res_repeat_password').val()) {
      if($('#comp_reset_password .rep-pw').hasClass('error')) {
        $('#comp_reset_password .rep-pw').removeClass('error');
        $('#comp_reset_password .reg-pw img').attr('src',regValid);
        $('#comp_reset_password .rep-pw img').attr('src',regValid);
        $('#comp_pwreset').removeAttr('disabled');
      }
    } 
    else {
      if(!$('#comp_reset_password .rep-pw').hasClass('error')) {
        $('#comp_reset_password .rep-pw').addClass('error');
        $('#comp_reset_password .rep-pw img').attr('src',regError);
        $('#comp_reset_password .reg-pw img').attr('src','');
        $('#comp_pwreset').attr('disabled', 'disabled');
      }
    }
  });
  
  
  $('#resetpw_customer_email').on('keyup', function () {
    if($(this).val() != '') {
      $('#acs-recover-pw').removeAttr('disabled');
    }
    else {
      $('#acs-recover-pw').attr('disabled', 'disabled');
    }
  });
  
  
  
  //Register User Modal
  $('#create_customer').on('submit', function(e) { //use on if jQuery 1.7+
    e.preventDefault();  //prevent form from submitting
    
    if ($('#customer_password').val() == $('#repeat_password').val()) {
      $('#register').addClass('reg-hide-button');
      $('.static-slideshow-loader.reg-loader-active').removeClass('reg-loader-inactive');
      var form = $(this);
      var url = form.attr('action');

      $.ajax({
        type: "POST",
        url: 'https://iq-shop.taqeef.com/account',
        data: form.serialize(), // serializes the form's elements.
        success: function(data, textStatus, xhr)
        {
          $('#register').removeClass('reg-hide-button');
          $('.static-slideshow-loader.reg-loader-active').addClass('reg-loader-inactive');
          if(data.includes("This email address is already associated with an account"))
          {
            $('.already-customer').html('This email address is already associated with an account.')
          }
          else
          {
            $('#register').removeClass('reg-hide-button');
            $('.static-slideshow-loader.reg-loader-active').addClass('reg-loader-inactive');
            //console.log(xhr.status);
            $('.reg-s1').attr('style','display:none;');
            $('.reg-s2').attr('style','display:block;');
            //console.log(data); // show response from the php script.
          }
        }
      });
    }
    
  });
  
  //Login User
  $('#customer_login').on('submit', function(e) { //use on if jQuery 1.7+
    e.preventDefault();  //prevent form from submitting
    
    $('#login').addClass('reg-hide-button');
    $('.static-slideshow-loader.reg-loader-active').removeClass('reg-loader-inactive');
    var form = $(this);
    var url = 'https://iq-shop.taqeef.com/account/login';
    
    $.ajax({
      type: "POST",
      url: url,
      data: form.serialize(), // serializes the form's elements.
      success: function(data, textStatus, xhr)
      {
        if(data.includes("Sorry! Please try that again."))
        {
          $('#login').removeClass('reg-hide-button');
          $('.static-slideshow-loader.reg-loader-active').addClass('reg-loader-inactive');
          
          if(!$('#customer_login h2').hasClass('err-act')) {
            $('#customer_login h2').addClass('err-act');
          }
          
          //alert("Incorrect username or password. Please try again.");
        }
        else
        {
          $('#login').removeClass('reg-hide-button');
          $('.static-slideshow-loader.reg-loader-active').addClass('reg-loader-inactive');
          
          if($('#customer_login h2').hasClass('err-act')) {
            $('#customer_login h2').removeClass('err-act');
          }
          
          $('#loginModal').modal('toggle');
          
          if(window.location.pathname == '/cart' || $('body').hasClass('template-product') == true) {
            window.location.href = '/checkout';
          }
          else {
            window.location.reload();
          }
          
          //console.log(xhr.status);
          //console.log(data); // show response from the php script.
        }
      }
    });
  });
  
  //Recover Password
  $('#reset_password').on('submit', function(e) {
    e.preventDefault();
    
    if($('#resetpw_customer_email').val() != '') 
    {
      $('#acs-recover-pw').addClass('reg-hide-button');
      $('.static-slideshow-loader.reg-loader-active').removeClass('reg-loader-inactive');
      var form = $(this);
      var url = 'https://iq-shop.taqeef.com/account/recover';

      $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(), // serializes the form's elements.
        success: function(data, textStatus, xhr)
        {
          if(data.includes("Sorry! Please try that again."))
          {
            $('#acs-recover-pw').removeClass('reg-hide-button');
            $('.static-slideshow-loader.reg-loader-active').addClass('reg-loader-inactive');

            alert("Something went wrong. Please try again.");
          }
          else
          {
            $('#acs-recover-pw').removeClass('reg-hide-button');
            $('.static-slideshow-loader.reg-loader-active').addClass('reg-loader-inactive');

            $('.fp-s1').attr('style','display:none;');
            $('.fp-s2').attr('style','display:block;');
            //console.log(xhr.status);
            //console.log(data); // show response from the php script.
          }
        },
        error: function(data, textStatus, xhr) {
          if(data.status == 429) {
            $('#reset_password h2').addClass('err-act');
            
            $('#acs-recover-pw').removeClass('reg-hide-button');
            $('.static-slideshow-loader.reg-loader-active').addClass('reg-loader-inactive');
          }
        }
      });
    }
    
  });
  
  //Comp recover
  $('.fp-s2 #cl_reset_password').on('submit', function(e) {
    e.preventDefault();
    $('#loginModal').modal('toggle');
  });
  
  //Comp reset
  $('#comp_reset_password').on('submit', function(e) {
    e.preventDefault();
    
    $('#comp_pwreset').addClass('reg-hide-button');
    $('.static-slideshow-loader.reg-loader-active').removeClass('reg-loader-inactive');
    var form = $(this);
    var url = 'https://iq-shop.taqeef.com/account/reset';

    $.ajax({
      type: "POST",
      url: url,
      data: form.serialize(), // serializes the form's elements.
      success: function(data, textStatus, xhr)
      {
        $('#comp_pwreset').removeClass('reg-hide-button');
        $('.static-slideshow-loader.reg-loader-active').addClass('reg-loader-inactive');

        $('.resetp-s1').attr('style','display:none;');
        $('.resetp-s2').attr('style','display:block;');
        
        //alert('paswrd changed');
      },
      error: function(data, textStatus, xhr) {
        $('#comp_pwreset').removeClass('reg-hide-button');
        $('.static-slideshow-loader.reg-loader-active').addClass('reg-loader-inactive');
        
        console.log(data.status);
      }
    });
  });
  
  
  //Display registration form
  $('#new-acc').on('click', function() {
    $('.log-s1').attr('style','display:none;');
    $('.reg-s1').attr('style','display:block;');
    $('.reg-s2').attr('style','display:none;');
    
    $('.fp-s1').attr('style','display:none;');
    $('.fp-s2').attr('style','display:none;');
  });
  
  $('#acs-login').on('click', function() {
    $('.log-s1').attr('style','display:block;');
    $('.reg-s1').attr('style','display:none;');
    $('.reg-s2').attr('style','display:none;');
    
    $('.fp-s1').attr('style','display:none;');
    $('.fp-s2').attr('style','display:none;');
  });
  
  //Clear values when modal is closed
  $('#loginModal').on('hidden.bs.modal', function () {
    $('.log-s1').attr('style','display:block;');
    $('.reg-s1').attr('style','display:none;');
    $('.reg-s2').attr('style','display:none;');
    $('.fp-s1').attr('style','display:none;');
    $('.fp-s2').attr('style','display:none;');
    
    $('#create_customer .reg-pw img').attr('src','');
    $('#create_customer .rep-pw img').attr('src','');
    
    $('#loginModal').find('input:text').val('');
    $('#loginModal').find('input:password').val('');
    
    $('.resetp-s1').attr('style','display:none;');
    $('.resetp-s2').attr('style','display:none;');
    
    $('form h2').removeClass('err-act');
  });
  
  $('#acs-reset-pws').on('click', function(e) {
    $('.resetp-s2').attr('style','display:none;');
    $('.log-s1').attr('style','display:block;');
  });
  
  
  
  //Reset Password
  $('.res-pw').on('click', function(e) {
    $('.log-s1').attr('style','display:none;');
    $('.reg-s1').attr('style','display:none;');
    $('.reg-s2').attr('style','display:none;');
    
    $('.fp-s1').attr('style','display:block;');
    $('.fp-s2').attr('style','display:none;');
  });
  
  function addUserInfo() {
    var items = refer.split('/');
    var token = items[4];
    var id = items[3];
    refer = '';
    
    var html = '<input type="hidden" name="token" value="' + token + '">';
    html  += '<input type="hidden" name="id" value="' + id + '">';
    
    document.getElementById("comp_reset_password").insertAdjacentHTML('beforeend', html);
  }
  
  
  
  
  
  
  
  
  
  //Product Filter
  var filters = {};
  
  var filteritems = [];
  var $grid = $('.collection-list').isotope({
    itemSelector: '.list-item',
    resize: true,
    getSortData: {
      indexsrt: '[data-indexsrt] parseInt',
      price: '[data-acprice] parseInt',
      tonnage: '[data-ton]',
      erating: '[data-rating]',
      id: '[id]'
    } 
  });
  
  $('.filter-items.dt input[type=checkbox]').change(function() {
    var group = $(this).parent().parent().attr('data-group');
    manageCheckbox($(this));
    var comboFilter = getComboFilter( filters );

    $grid.isotope({ filter: comboFilter });
    
    
    /* if(this.checked == true)
    {
      filteritems.push('.' + $(this).attr('id'));
      $grid.isotope({ filter: filteritems.join('')});
    }
    else
    {
      var index = filteritems.indexOf('.' + $(this).attr('id'));
      filteritems.splice(index, 1);
      
      if(filteritems.length == 0)
      {
        $grid.isotope({ filter: '*'});
      }
      else
      {
        $grid.isotope({ filter: filteritems.join('')});
      }
    } */
  });
  
  $grid.on( 'arrangeComplete',
    function( event, filteredItems ) {
      if (filteredItems.length == 0) {
        $('.filter-error').attr('style','visibility: visible; opacity: 1; padding-bottom: 50px;'); 
      } else {
        $('.filter-error').attr('style','visibility: hidden; opacity: 0; padding-bottom: 0;');
      }
    }
  );
  
  $('.clear-filters').on('click', function(){
    $('.filter-items input[type=checkbox]').prop('checked',false);
    $grid.isotope({ filter: '*'});
    delete filters[ 'type' ];
    delete filters[ 'comp' ];
    $('.sort-select > p').html('Sort by');
    $grid.isotope({ sortBy : 'id', sortAscending: false });
  });
  
  
  //Product Sort $grid.isotope({ sortBy : 'symbol' });
  $('.sortsel-item').on('click', function(){
    
    switch($(this).attr('value')) {
     case 'price-asc':
        $grid.isotope({ sortBy : 'price', sortAscending: true });
        break;
     case 'price-dsc':
        $grid.isotope({ sortBy : 'price', sortAscending: false });
        break;
     case 'ton-asc':
        $grid.isotope({ sortBy : 'tonnage', sortAscending: true });
        break;
     case 'ton-dsc':
        $grid.isotope({ sortBy : 'tonnage', sortAscending: false });
        break; energy-htl
     case 'energy-htl':
        $grid.isotope({ sortBy : 'erating', sortAscending: false });
        break;
     case 'best-selling':
        $grid.isotope({ sortBy : 'original-order', sortAscending: false });
        break;
     default:
      $grid.isotope({ sortBy : 'erating'});
    }
    
  });
  
  $grid.isotope({ sortBy : 'indexsrt', sortAscending: true });
  
  
  
  
  //Mobile Sort
  var mb_sortitems = [];
  var sortObj = {price:true, tonnage:true, erating:true};
  
  $('.sort-select.sort-mobile').on('click',function(){
    $('.mobile-sort-container').addClass('active');
    $('body').addClass('nav-open');
  });
  
  $('.filter-items.sort-mb input[type=checkbox]').change(function() {
    if(this.checked == true)
    {
      switch($(this).attr('id')) {
        case 'price-asc': 
          mb_sortitems.push('price');
          sortObj.price = true;
          break;
        case 'price-dsc':
          mb_sortitems.push('price');
          sortObj.price = false;
          break;
        case 'ton-asc':
          mb_sortitems.push('tonnage');
          sortObj.tonnage = true;
          break;
        case 'ton-dsc':
          mb_sortitems.push('tonnage');
          sortObj.tonnage = false;
          break;
        case 'energy-htl':
          mb_sortitems.push('erating');
          sortObj.erating = false;
          break;
        default:
          //$grid.isotope({ sortBy : 'original-order'});
      }
    }
    else
    {
      switch($(this).attr('id')) {
        case 'price-asc':
          var index = mb_sortitems.indexOf('price');
          mb_sortitems.splice(index, 1);
          break;
        case 'price-dsc':
          var index = mb_sortitems.indexOf('price');
          mb_sortitems.splice(index, 1);
          break;
        case 'ton-asc':
          var index = mb_sortitems.indexOf('tonnage');
          mb_sortitems.splice(index, 1);
          break;
        case 'ton-dsc':
          var index = mb_sortitems.indexOf('tonnage');
          mb_sortitems.splice(index, 1);
          break;
        case 'energy-htl':
          var index = mb_sortitems.indexOf('erating');
          mb_sortitems.splice(index, 1);
          sortObj.erating = true;
          break;
        default:
          //$grid.isotope({ sortBy : 'original-order'});
      }
    }
  });
  
  $('#m-sort').on('click', function() {
    //console.log('[' + "'" + mb_sortitems.join("','") + "'" + ']');
    //console.log(JSON.stringify(sortObj).replace(/"([^"]+)":/g, '$1:'));
    if(mb_sortitems.length == 0)
    { $grid.isotope({ sortBy: 'original-order'}); closeMobileSort(); }
    else 
    { $grid.isotope({ sortBy: mb_sortitems.toString(), sortAscending: sortObj}); closeMobileSort(); }
  });
  
  $('#m-close-sort').on('click', function(){
    closeMobileSort();
  });
  
  $('.close-sort').on('click', function(){
    closeMobileSort();
  });
  
  function closeMobileSort() {
    if($('.mobile-sort-container').hasClass('active'))
    { $('.mobile-sort-container').removeClass('active'); $('body').removeClass('nav-open'); }
  }
  
  $('.clear-sort-mobile').on('click', function() {
    $('.filter-items.sort-mb input[type=checkbox]').prop('checked',false);
    $grid.isotope({ sortBy : 'id', sortAscending: false });
  });
  
  
  
  
  //Mobile Filter
  var mb_filteritems = [];
  
  $('.sort-select.filter-mobile').on('click',function(){
    $('.mobile-filters-container').addClass('active');
    $('body').addClass('nav-open');
  });
  
  $('.filter-items.mb input[type=checkbox]').change(function() {
    /* if(this.checked == true)
    {
      mb_filteritems.push('.' + $(this).attr('id'));
    }
    else
    {
      var index = mb_filteritems.indexOf('.' + $(this).attr('id'));
      mb_filteritems.splice(index, 1);
    } */
    
    var group = $(this).parent().parent().attr('data-group');
    manageCheckbox($(this));
    
  });
  
  
  $('#m-filter').on('click', function() {
    
    var comboFilter = getComboFilter( filters );
    $grid.isotope({ filter: comboFilter });
    closeMobileFilter();
    
    /* if(mb_filteritems.length == 0)
    { 
      $grid.isotope({ filter: '*'}); closeMobileFilter(); }
    else 
    { $grid.isotope({ filter: mb_filteritems.toString()}); closeMobileFilter(); } */
    
  });
  
  $('.close-filter').on('click', function(){
    closeMobileFilter();
  });
  
  $('#m-close-filter').on('click', function(){
    closeMobileFilter();
  });
  
  function closeMobileFilter() {
    if($('.mobile-filters-container').hasClass('active'))
    { $('.mobile-filters-container').removeClass('active'); $('body').removeClass('nav-open'); }
  }
  
  $('.clear-filter-mobile').on('click', function(){
    $('.filter-items.filter-items.mb input[type=checkbox]').prop('checked',false);
    $grid.isotope({ filter: '*'});
    delete filters[ 'type' ];
    delete filters[ 'comp' ];
  });
  
  
  
  
  
  
  
  //Mobile Nav
  $('.menu-toggle').on('click', function() {
    if(!$('.mobile-nav-container').hasClass('active')) {
      $('.mobile-nav-container').addClass('active');
      /* $(".mobile-nav-container").animate({height: '100vh'}, 600, function(){
        setTimeout(function(){ $(".mobile-nav-container").addClass('fixed'); }, 500);
      }); */
      $('.mobile-header').addClass('nav-open');
    }
  });
  
  $('.menu-back-toggle').on('click', function() {
    if($('.mobile-nav-container').hasClass('active')) {
      $('.mobile-nav-container').removeClass('active').removeClass('fixed');
      //$(".mobile-nav-container").animate({height: '0'});
      $('.mobile-header').removeClass('nav-open');
    }
  });
  
  
  //Mobile search Opem
  $('.mobile-nav-top .menu-search-toggle img').on('click', function() {
    if(!$('.mobile-nav-top .menu-search-toggle').hasClass('active'))  {
      var searchGrid = document.getElementById('msearch-res');
      searchGrid.innerHTML = '';
      
      $('.mobile-nav-top .menu-search-toggle').addClass('active');
      $('.menu-search-close-toggle').attr('style','display:block;');
      $('.mobile-header-search-input').attr('style','display:block !important;');
      $('.menu-back-toggle').attr('style', 'display:none;');
      $('.mobile-search-results').attr('style', 'display:block;');
      $('.mobile-header-search-input').val('');
    }
  });
  
  // Close
  $('.mobile-nav-top .menu-search-close-toggle img').on('click', function() {
    if($('.mobile-nav-top .menu-search-toggle').hasClass('active'))  {
      $('.mobile-nav-top .menu-search-toggle').removeClass('active');
      $('.menu-search-close-toggle').attr('style','display:none;');
      $('.mobile-header-search-input').attr('style','display:none !important;');
      $('.menu-back-toggle').attr('style', 'display:block;');
      $('.mobile-search-results').attr('style', 'display:none;');
      
      var searchGrid = document.getElementById('msearch-res');
      searchGrid.innerHTML = '';
      $('.mobile-header-search-input').val('');
    }
  });
  
  
  
  //Terms Select
  $('.website-terms-select').on('click', function() {
    if($('.sub-links-mobile').hasClass('active')) {
      $('.website-terms-select').removeClass('active');
      $('.sub-links-mobile').removeClass('active');
    }
    else {
      $('.website-terms-select').addClass('active');
      $('.sub-links-mobile').addClass('active');
    }
  });
  
  
  

  
  //Update Cart Quantity
  $('.icon-plus').on('click', function(e) {
    var _this = $(this);
    var didFindVariant = false;
    
    var p_type = $(this).parent().parent().parent().parent().attr('data-type');
    
    /*
    if(p_type == 'professional-installation') 
    {
      var mainPid = $(this).parent().parent().parent().parent().attr('data-opid');
      $('.cart-item').each(function (i, row) {
        if($(row).attr('data-opid') == mainPid && $(row).attr('data-type') == 'normal')
        {
          didFindVariant = true;
          var ac_qty = $(row).find('.cart-quantity-input').val();
          if($(this).parent().parent().find('.cart-quantity-input').val() < ac_qty) 
          {
            var rowidx = $(_this).attr('data-itemrow');

            var currentQty = $('#cart-' + rowidx + '-quantity').val();
            var newQty = ++currentQty;

            $('#cart-' + rowidx + '-quantity').val(newQty);
            updateCartQty(rowidx, newQty);
          }
          else
          {
            console.log('Cant add more professional installtions than acs.');
          }
        }
      });
      
      if(didFindVariant == false) 
      {
        var row = $(this).attr('data-itemrow');

        var currentQty = $('#cart-' + row + '-quantity').val();
        var newQty = ++currentQty;

        $('#cart-' + row + '-quantity').val(newQty);
        updateCartQty(row, newQty);
      }
    }
    else 
    {
      var row = $(this).attr('data-itemrow');

      var currentQty = $('#cart-' + row + '-quantity').val();
      var newQty = ++currentQty;

      $('#cart-' + row + '-quantity').val(newQty);
      updateCartQty(row, newQty);
    }
    */
    
    var row = $(this).attr('data-itemrow');

    var currentQty = $('#cart-' + row + '-quantity').val();
    var stockAvailable = $('#cart-' + row + '-quantity').attr('data-stk');
    var newQty = ++currentQty;

    if(newQty <= stockAvailable) {
      $('#cart-' + row + '-quantity').val(newQty);
      updateCartQty(row, newQty);
    }
  });
  
  $('.icon-minus').on('click', function(e) {
    var _this = $(this);
    var didFindVariant = false;
    
    /*
    var p_type = $(this).parent().parent().parent().parent().attr('data-type');
    if(p_type == 'normal') 
    {
      var mainPid = $(this).parent().parent().parent().parent().attr('data-opid');
      $('.cart-item').each(function (i, row) {
        if($(row).attr('data-opid') == mainPid && $(row).attr('data-type') == 'professional-installation') 
        {
          didFindVariant = true;
          var profinsqty = $(row).find('.cart-quantity-input').val();
          var profinsrow = $(row).find('.cart-quantity-input').attr('data-itemrow');
          
          var rowidx = $(_this).attr('data-itemrow');
          var currentQty = $('#cart-' + rowidx + '-quantity').val();
          
          if(profinsqty == currentQty) 
          {
            var newQty = --currentQty;
            if(newQty >= 1) {
              $('#cart-' + rowidx + '-quantity').val(newQty);
              $('#cart-' + profinsrow + '-quantity').val(newQty);
              
              var jsonArr = [];
              jsonArr.push({line: rowidx, quantity: newQty});
              jsonArr.push({line: profinsrow, quantity: newQty});
              
              updateCartQty(rowidx, newQty);
              setTimeout(function() {
                updateCartQty(profinsrow, newQty);
              }, 1000);
              
            }
          }
          else
          {
            var rowidx = $(_this).attr('data-itemrow');
            var currentQty = $('#cart-' + rowidx + '-quantity').val();
            var newQty = --currentQty;

            if(newQty >= 1) {
              $('#cart-' + rowidx + '-quantity').val(newQty);
              updateCartQty(rowidx, newQty);
            }
          }
        }
      });
      
      if(didFindVariant == false) 
      {
        var row = $(this).attr('data-itemrow');

        var currentQty = $('#cart-' + row + '-quantity').val();
        var newQty = --currentQty;

        $('#cart-' + row + '-quantity').val(newQty);
        updateCartQty(row, newQty);
      }
    }
    else 
    {
      var rowidx = $(_this).attr('data-itemrow');
      var currentQty = $('#cart-' + rowidx + '-quantity').val();
      var newQty = --currentQty;

      if(newQty >= 1) {
        $('#cart-' + rowidx + '-quantity').val(newQty);
        updateCartQty(rowidx, newQty);
      }
    }
    */
    
    var rowidx = $(_this).attr('data-itemrow');
    var currentQty = $('#cart-' + rowidx + '-quantity').val();
    var newQty = --currentQty;

    if(newQty >= 1) {
      $('#cart-' + rowidx + '-quantity').val(newQty);
      updateCartQty(rowidx, newQty);
    }
    
  });
  
  
  
  
  
  var currentprofitem = '';
  $('.cart-quantity-input').on('focusin', function(){
    var p_type = $(this).parent().parent().parent().parent().attr('data-type');
    if(p_type == 'professional-installation') 
    {
      currentprofitem = $(this).val(); 
    }
  });

  
  $('.cart-quantity-input').on('input',function(e) {
    var _this = $(this);
    
    /*
    var p_type = $(this).parent().parent().parent().parent().attr('data-type');
    if(p_type == 'professional-installation') 
    {
      var mainPid = $(this).parent().parent().parent().parent().attr('data-opid');
      $('.cart-item').each(function (i, row) {
        if($(row).attr('data-opid') == mainPid && $(row).attr('data-type') == 'normal') 
        {
          var ac_qty = $(row).find('.cart-quantity-input').val();
          var newQty = $(_this).val();
          var rowidx = $(_this).attr('data-itemrow');
          
          if(newQty < ac_qty) 
          {
            if(newQty >= 1) 
            {
              updateCartQty(rowidx, newQty);
            }
          }
          else {
            console.log('Cant add more professional installtions than acs.');
            $(_this).val(currentprofitem);
          }
          
        }
      });
    }
    else
    {
      var row = $(this).attr('data-itemrow');
      var newQty = $(this).val();

      if(newQty >= 1) {
        updateCartQty(row, newQty);
      }
    }
    */
    
    var row = $(this).attr('data-itemrow');
    var newQty = $(this).val();

    if(newQty >= 1) {
      updateCartQty(row, newQty);
    }
  });

  
  function updateCartQty(varientid, new_quantity) {
    $.ajax({
      type: 'POST', 
      url: '/cart/change.js',
      dataType: 'json',
      data: {line:varientid, quantity:new_quantity},
      success: function(data) {
        //alert('Cart udpated');
        updateCartTotal();
      },
      error: function(data) {
      }
    });
  }
  
  function updateCartTotal() {
    $.ajax({
      type: 'GET', 
      url: '/cart.js',
      dataType: 'json',
      success: function(data) {
        //alert('Cart udpated');
        var newTotal = data.total_price;
        $('.cart-price .money').html(aedFormat(newTotal) + ' AED');
        
        data.items.forEach(function(item, i) {
          //console.log(new Intl.NumberFormat('en-AE',{ style: 'currency', currency: 'AED' }).format(item.final_line_price));
          $('.cart-item-final-price.money.' + (i+1) + '').html((aedFormat(item.final_line_price)) + ' AED');
        });
      },
      error: function(data) {
      }
    });
  }
  
  function aedFormat(money) {
    var nf = new Intl.NumberFormat();
    return nf.format((money/100).toFixed(2));
  }
  
  
  /*
  $.ajax({
    type: 'GET', 
    url: '/cart.js',
    dataType: 'json',
    success: function(data) {
      //alert('Cart udpated');
      var newTotal = data.total_price;
      $('.cart-price .money').html(aedFormat(newTotal) + '.00 AED');

      data.items.forEach(function(item, i) {
        //console.log(new Intl.NumberFormat('en-AE',{ style: 'currency', currency: 'AED' }).format(item.final_line_price));
        if(item.variant_title.includes('Add installation')) {
          var newtitle = 'Professional Installation of' + item.title; 
          updateCartTitle((i+1), newtitle);
        }
      });
    },
    error: function(data) {
    }
  });
  
  function updateCartTitle(varientid, new_title) {
    $.ajax({
      type: 'POST', 
      url: '/cart/change.js',
      dataType: 'json',
      data: {line:varientid, title:new_title},
      success: function(data) {
        //alert('Cart udpated');
        //console.log(JSON.stringify(data));
      },
      error: function(data) {
      }
    });
  }
  */
 
  
  $('#discount-10').on('submit', function(e) {
    e.preventDefault();
    var cEmail = $('#customer_email').val();
    
    $('#disc-10').addClass('reg-hide-button');
    $('.static-slideshow-loader.reg-loader-active').removeClass('reg-loader-inactive');
    
    $.ajax({
      type: 'GET', 
      url: 'https://tech.taqeef.com/tech/taq/taq-getproducts.php?type=discount&customerEmail=' + cEmail + '',
      success: function(data) {
        //console.log(data);
        if(data == 1) {
          $('#customer_email').val('');
          
          $('#disc-10').removeClass('reg-hide-button');
          $('.static-slideshow-loader.reg-loader-active').addClass('reg-loader-inactive');
          
          $('#create_customer.dialogModal h2').html('Success!');
          $('#create_customer.dialogModal p').html('Thank You, We have emailed you the discount code.');
          
          $('#messageDialogModal').modal('toggle');
          //alert('Check your email for the code!');
        }
      },
      error: function(data) {
        //console.log(JSON.stringify(data));      
        
        $('#disc-10').removeClass('reg-hide-button');
        $('.static-slideshow-loader.reg-loader-active').addClass('reg-loader-inactive');
        
        $('#create_customer.dialogModal h2').html('Failed');
        $('#create_customer.dialogModal p').html('Unable to process the request Please try again.');

        $('#messageDialogModal').modal('toggle');
      }
    });
  });
  
  
  
  //10% Discount Popup
  $('#discountPopup').on('submit', function(e) {
    e.preventDefault();
    var cEmail = $('#popupDiscount_email').val();
    //console.log(cEmail);
    
    $('#disc-10-popup').addClass('reg-hide-button');
    $('.static-slideshow-loader.reg-loader-active').removeClass('reg-loader-inactive');
    
    $.ajax({
      type: 'GET', 
      url: 'https://tech.taqeef.com/tech/taq/taq-getproducts.php?type=discount&customerEmail=' + cEmail + '',
      success: function(data) {
        //console.log(data);
        if(data == 1) {
          $('#customer_email').val('');
          
          $('#disc-10-popup').removeClass('reg-hide-button');
          $('.static-slideshow-loader.reg-loader-active').addClass('reg-loader-inactive');
          
          $('.coolcare-contact.10-discount').attr('style','display:none');
          $('.coolcare-contact-success.10-discount').attr('style','display:block');
          //$('#create_customer.dialogModal h2').html('Success!');
          //$('#create_customer.dialogModal p').html('Thank You, We have emailed you the discount code.');
          
          //$('#offer10Modal').modal('toggle');
          //$('#messageDialogModal').modal('toggle');
          //alert('Check your email for the code!');
        }
      },
      error: function(data) {
        //console.log(JSON.stringify(data));      
        
        $('#disc-10-popup').removeClass('reg-hide-button');
        $('.static-slideshow-loader.reg-loader-active').addClass('reg-loader-inactive');
        
        $('.coolcare-contact.10-discount').attr('style','display:none');
        $('.coolcare-contact-success.10-discount').attr('style','display:block');
        /* $('#create_customer.dialogModal h2').html('Failed');
        $('#create_customer.dialogModal p').html('Unable to process the request Please try again.');

        $('#offer10Modal').modal('toggle');
        $('#messageDialogModal').modal('toggle'); */
      }
    });
  });
  
  $('#tds-close').on('click', function(e){
    $('#offer10Modal').modal('toggle');
    
    if($('#offer10Modal  h2').hasClass('err-act')) {
      $('#offer10Modal h2').removeClass('err-act');
    }
    
    $('#popupDiscount_email').val('');
    
    $('.coolcare-contact.10-discount').attr('style','display:block');
        $('.coolcare-contact-success.10-discount').attr('style','display:none');
  });
  
  
  
  
  $('#coolcare_contact').on('submit', function(e) {
    e.preventDefault();
    
    var toEmail = "coolprotect@taqeef.com"; 
    var cFirstName = $('#first_name').val();
    var cLastName = $('#last_name').val();
    var cTel = $('#phone').val();
    var cMsg = $('#message').val();
    
    /*if(cTel.length == 0 || cTel.length != 10){
      $('#phone').attr('style','border-color: #dc3545')
      $('.mob-err').html('Invalid Phone number.');
      return;
    }*/
    
    
    $('#coolcare-contact-sub').addClass('reg-hide-button');
    $('.static-slideshow-loader.reg-loader-active').removeClass('reg-loader-inactive');
    
    $.ajax({
      type: 'GET', 
      url: 'https://tech.taqeef.com/tech/taq/taq-getproducts.php?type=coolcare_contact&customerFname=' + cFirstName + '&customerLname=' + cLastName + '&customerMnum=' + cTel + '&toEmail=' + toEmail + '&msg=' + cMsg +'',
      success: function(data) {
        //console.log(data);
        if(data == 1) {
          $('#first_name').val('');
          $('#last_name').val('');
          $('#phone').val('');
          $('#msg').val('');
          
          $('#coolcare-contact-sub').removeClass('reg-hide-button');
          $('.static-slideshow-loader.reg-loader-active').addClass('reg-loader-inactive');
          
          $('.coolcare-contact').attr('style','display:none');
          $('.coolcare-contact-success').attr('style','display:block');
          
          //$('#coolcareContactModal').modal('toggle');
          //alert('Your mail has been sent!');
        }
      },
      error: function(data) {
        //console.log(JSON.stringify(data));      
        $('#coolcare-contact-sub').removeClass('reg-hide-button');
        $('.static-slideshow-loader.reg-loader-active').addClass('reg-loader-inactive');
        
        if(!$('#coolcare_contact  h2').hasClass('err-act')) {
          $('#coolcare_contact h2').addClass('err-act');
        }
      }
    });
  });
  
  $(document).on("input", "#phone", function() {
      this.value = this.value.replace(/\D/g,'');
  });
  
  $('#ccs-close').on('click', function(e){
    $('#coolcareContactModal').modal('toggle');
    
    if($('#coolcare_contact  h2').hasClass('err-act')) {
      $('#coolcare_contact h2').removeClass('err-act');
    }
    
    $('#first_name').val('');
    $('#last_name').val('');
    $('#phone').val('');
    $('#message').val('');
    
    $('#phone').attr('style','')
    $('.mob-err').html('');
    
    $('.coolcare-contact').attr('style','display:block');
    $('.coolcare-contact-success').attr('style','display:none');
  });
  
  $('#coolcareContactModal').on('hidden.bs.modal', function () {
    if($('#coolcare_contact  h2').hasClass('err-act')) {
      $('#coolcare_contact h2').removeClass('err-act');
    }
    
    $('#first_name').val('');
    $('#last_name').val('');
    $('#phone').val('');
    $('#message').val('');
    
    $('#phone').attr('style','')
    $('.mob-err').html('');
    
    $('.coolcare-contact').attr('style','display:block');
    $('.coolcare-contact-success').attr('style','display:none');
  });
  
  
  $('#msgdialog-close').on('click', function(e) {
    $('#messageDialogModal').modal('toggle');
  })
  
  
  
  
  
  
  var query = getQueryParams(document.location.search);
  if(query != null)
  {
    if(window.location.pathname == '/collections/all')
    {
      var baseUrl = "https://iq-shop.taqeef.com";
      var allProductshGrid = document.getElementById('allproducts-grid');
      allProductshGrid.html = '';
      
      //console.log(allProds);
      var productsFound = [];
      
      $.ajax({
        type: "GET",
        url: 'https://tech.taqeef.com/taq/taq-getproducts.php?type=globalproducts&baseurl=' + baseUrl + '',
        success: function(data, textStatus, xhr)
        {
          //console.log(data);
          data = JSON.parse(data);
          data.products.forEach(function(item) {
            //console.log(item.vendor.toLowerCase());
            if(query.vendor != null && item.vendor.toLowerCase().replace(' ','-') == query.vendor.toLowerCase()) {
              productsFound.push(item);
            }
            else if(query.vendor.toLowerCase() == 'all' || query.type != null) {
              productsFound.push(item);
            }
          });

          if(productsFound != null && productsFound.length > 0)
          {
            getMetaFieldsAllProducts(productsFound, query, allProductshGrid, baseUrl);
          }
        }
      });
      
    }
  }
  
  function getMetaFieldsAllProducts(data, query, allProductshGrid, baseUrl)
  { 
    data.forEach(function(item) {
      var metaurl = 'https://tech.taqeef.com/taq/taq-getproducts.php?type=metadata&baseurl=' + baseUrl + '&pid=' + item.id + '';
      
      $.ajax({
          type: "GET",
          //url: baseUrl + '/admin/api/2021-04/products/' + item.id + '/metafields.json',
          url: metaurl,
          success: function(metadata, textStatus, xhr)
          {
            //console.log(metadata);
            metadata = JSON.parse(metadata);
            var ac_type = '';
            var ton = '';
            var comp = '';
            
            metadata.metafields.forEach(function(metaobj) {
              if(metaobj.key == 'ac-type') { ac_type = metaobj.value; }
              if(metaobj.key == 'ac-tonnage') { ton = metaobj.value; }
              if(metaobj.key == 'ac-compressor') { comp = metaobj.value; }
            });

            if(query.type != null) 
            {
              //console.log(ac_type.toLowerCase());
              if(query.type.toLowerCase() == ac_type.toLowerCase().replace(' ','-')) {
                var proditem = popGlobalSearchItem(item, ton, comp, ac_type);
                allProductshGrid.insertAdjacentHTML('beforeend', proditem);
              }
            }
            else 
            {
              var proditem = popGlobalSearchItem(item, ton, comp, ac_type);
              allProductshGrid.insertAdjacentHTML('beforeend', proditem);
            }
            
          }
      });
    });
    
    //$('.search-results').addClass('search-results-show');
  }
  
  function popGlobalSearchItem(item, tonnage, compressor, actype) 
  {
    var baseUrl = "https://iq-shop.taqeef.com";
    
    var globalItem = '';
    globalItem +=   '<div class="list-item product-list-item ' + compressor.toLowerCase() + ' ' + actype.toLowerCase() + '" data-ton="' + tonnage + '" data-product-item="" >';
    globalItem +=    '<a class="list-container" href="' + baseUrl + '/products/' + item.handle + '" style="text-decoration: none; background-color: #fff;">';
    globalItem +=         '<div class="list-image-wrapper">';
    globalItem +=             '<div class="list-cover">';
    globalItem +=                   '<img src="' + item.image.src + '" class="list-image" alt="' + (item.title ? item.title.replace(/"/g, '&quot;') : 'Product Image') + '" />';
    globalItem +=             '</div>';
    globalItem +=         '</div>';
    globalItem +=       '<div class="card-body main-content" style="text-align: left;">';
    globalItem +=           '<h2 class="card-title">' + item.title + '</h2>';
    globalItem +=             '<p class="card-text">' + tonnage + ' TON<span>|</span> ' + compressor + ' compressor<br/>by ' + item.vendor + '</p>';
    globalItem +=       '</div>';
    globalItem +=       '<div class="card-body sub-content" style="text-align: left;">';
    globalItem +=           '<span class="price">' + item.variants[0].price + ' AED<br /><span>inc. VAT</span></span>';
    globalItem +=             '<div class="listitem-addtocart" href=""><img src="//cdn.shopify.com/s/files/1/0528/7290/4876/t/2/assets/add-to-cart.svg?v=7960375700957403316" alt="Add to cart" aria-hidden="true" /></div>'
    globalItem +=         '</div>';
    globalItem +=   ' </a>';
    globalItem +=   '</div>';

    return globalItem;
  }
  
  function getQueryParams(qs) 
  {
    qs = qs.split('+').join(' ');
    var params = {}, tokens, re = /[?&]?([^=]+)=([^&]*)/g;

    while (tokens = re.exec(qs)) {
      params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }
    return params;
  }
  
  
  $('.play-video.show-vid').on('click', function(){
    $('#VideoPlayerModal').modal('toggle');
    var video = $('#cc-vid');
    video[0].play();
  });
  
  $('#VideoPlayerModal').on('hidden.bs.modal', function () {
    var video = $('#cc-vid');
    video[0].pause();
  });
  
  /*
  $('.play-video').on('click',function(e){
    var video = $(this).parent().parent().children('video');
    //console.log(video);
    if (video[0].paused == true) {
      // Play the video
      video[0].play();
      $('.play-title').attr('style','display:none');
      $(this).children('#play').attr('style','display:none');
      $(this).children('#pause').attr('style','display:block');
      // Update the button text to 'Pause'
      //playButton.innerHTML = "Pause";
    } else {
      // Pause the video
      video[0].pause();
      $('.play-title').attr('style','display:block');
      $(this).children('#play').attr('style','display:block');
      $(this).children('#pause').attr('style','display:none');
      // Update the button text to 'Play'
      //playButton.innerHTML = "Play";
    }
  });
  */
  
  function getComboFilter( filters ) {
    var i = 0;
    var comboFilters = [];
    var message = [];

    for ( var prop in filters ) {
      message.push( filters[ prop ].join(' ') );
      var filterGroup = filters[ prop ];
      // skip to next filter group if it doesn't have any values
      if ( !filterGroup.length ) {
        continue;
      }
      if ( i === 0 ) {
        // copy to new array
        comboFilters = filterGroup.slice(0);
      } else {
        var filterSelectors = [];
        // copy to fresh array
        var groupCombo = comboFilters.slice(0); // [ A, B ]
        // merge filter Groups
        for (var k=0, len3 = filterGroup.length; k < len3; k++) {
          for (var j=0, len2 = groupCombo.length; j < len2; j++) {
            filterSelectors.push( groupCombo[j] + filterGroup[k] ); // [ 1, 2 ]
          }

        }
        // apply filter selectors to combo filters for next group
        comboFilters = filterSelectors;
      }
      i++;
    }

    var comboFilter = comboFilters.join(', ');
    return comboFilter;
  }
  function manageCheckbox( $checkbox ) {
  var checkbox = $checkbox[0];

  var group = $checkbox.parent().parent().attr('data-group');
  // create array for filter group, if not there yet
  var filterGroup = filters[ group ];
  if ( !filterGroup ) {
    filterGroup = filters[ group ] = [];
  }

  var isAll = $checkbox.hasClass('all');
  // reset filter group if the all box was checked
  if ( isAll ) {
    delete filters[ group ];
    if ( !checkbox.checked ) {
      checkbox.checked = 'checked';
    }
  }
  // index of
  var index = $.inArray( checkbox.value, filterGroup );

  if ( checkbox.checked ) {
    var selector = isAll ? 'input' : 'input.all';
    $checkbox.siblings( selector ).removeAttr('checked');


    if ( !isAll && index === -1 ) {
      // add filter to group
      filters[ group ].push( checkbox.value );
    }

  } else if ( !isAll ) {
    // remove filter from group
    filters[ group ].splice( index, 1 );
    // if unchecked the last box, check the all
    if ( !$checkbox.siblings('[checked]').length ) {
      $checkbox.siblings('input.all').attr('checked', 'checked');
    }
  }

}
  
  
});

function allprdts()
{
  var baseUrl = "https://iq-shop.taqeef.com";
  
  $.ajax({
    type: "GET",
    url: 'https://tech.taqeef.com/taq/taq-getproducts.php?type=globalproducts&baseurl=' + baseUrl + '',
    success: function(data, textStatus, xhr)
    {
      //console.log(data);
      data = JSON.parse(data);
      if(data != null && data.products.length > 0)
      {
        allProds = data;
      }
    }
  });
}


window.stockistWidgetLoaded = function() {
  // Stockist DOM has loaded - make customizations here
  var clearBtn  =  '<span class="storelocator-search-clear">';
  clearBtn    +=  '<button type="button"><img style="width:16px; height:16px;" src="https://cdn.shopify.com/s/files/1/0528/7290/4876/files/store-locator-close-icon.svg?v=1633508089" alt="Clear" aria-hidden="true"></button>';
  clearBtn    += '</span>';
  
  //Append the button
  $('.stockist-query-entry').append(clearBtn);
  
  
  //Show button if theres text on the input
  $('.stockist-search-field').on('input',function(e) {
    if($(this).val().length > 0 ) {
      $('.storelocator-search-clear button').addClass('active');
    }
    else {
      $('.storelocator-search-clear button').removeClass('active');
    }
  });
  
  //Clear the textbox if text is present
  $('.storelocator-search-clear button').on('click', function(e) {
    if($('.stockist-search-field').val().length > 0 ) {
      $('.stockist-search-field').val('');
      $('.storelocator-search-clear button').removeClass('active');
    }
  });
  
  $('#stockist-widget').find('form').submit(function(e) {
    $('.stockist-result-list').attr('style','display:block');
  });
}


//Page last updated
if(typeof _lpageId !== 'undefined') 
{
  var baseUrl = "https://taqeef.myshopify.com";
  $.ajax({
    type: "GET",
    url: 'https://tech.taqeef.com/taq/taq-getproducts.php?type=legalUDate&baseurl=' + baseUrl + '&pageId='+ _lpageId +'',
    success: function(data, textStatus, xhr)
    {
      data = JSON.parse(data);
      if(data != null)
      {
        if(data.page.handle == 'website-terms-of-use' || data.page.handle == 'privacy-policy')
        {
          var dateObj = new Date(data.page.updated_at);
          var dateText = 'Last updated: '+ dateObj.getDate() + ' ' + dateObj.toLocaleString('default', { month: 'long' })  + ', ' + dateObj.getFullYear();
          $('.legal-page-content .page-body.rte p').first().html(dateText);
        }
      }
    }
  });
}


//Intrests Page Email
$('#intrests_info').on('submit', function(e) {
  e.preventDefault();

  //var toEmail = "support@bettarit.co.uk"; 
  var toEmail = "shop@taqeef.com"; 
  var cName = $('#name').val();
  var cTel = $('#phone').val();
  var cEmail = $('#email').val();

  /*if(cTel.length == 0 || cTel.length != 10){
      $('#phone').attr('style','border-color: #dc3545')
      $('.mob-err').html('Invalid Phone number.');
      return;
    }*/


  $('#taqeef-contact-sub').addClass('reg-hide-button');
  $('.static-slideshow-loader.reg-loader-active').removeClass('reg-loader-inactive');

  $.ajax({
    type: 'GET', 
    url: 'https://tech.taqeef.com/taq/taq-getproducts.php?type=ogenintrests&customerName=' + cName + '&customerMnum=' + cTel + '&toEmail=' + toEmail + '&customerEmail=' + cEmail +'',
    success: function(data) {
      //console.log(data);
      if(data == 1) {
        $('#name').val('');
        $('#phone').val('');
        $('#email').val('');

        $('#taqeef-contact-sub').removeClass('reg-hide-button');
        $('.static-slideshow-loader.reg-loader-active').addClass('reg-loader-inactive');

        $('.taqeef-contact-container').attr('style','display:none');
        $('.taqeef-form-success').attr('style','display:block');

        //$('#coolcareContactModal').modal('toggle');
        //alert('Your mail has been sent!');
      }
    },
    error: function(data) {
      //console.log(JSON.stringify(data));      
      $('#taqeef-contact-sub').removeClass('reg-hide-button');
      $('.static-slideshow-loader.reg-loader-active').addClass('reg-loader-inactive');

      if(!$('#coolcare_contact  h2').hasClass('err-act')) {
        $('#coolcare_contact h2').addClass('err-act');
      }
    }
  });
});

$('#tf-close').on('click', function(e) {

  if($('.taqeef-form  h2').hasClass('err-act')) {
    $('.taqeef-form h2').removeClass('err-act');
  }

  $('#name').val('');
  $('#phone').val('');
  $('#email').val('');

  $('#phone').attr('style','')
  $('.mob-err').html('');

  $('.taqeef-contact-container').attr('style','display:block');
  $('.taqeef-form-success').attr('style','display:none');
});

document.addEventListener('DOMContentLoaded', function() {
  // Toggle dropdowns
  document.querySelectorAll('[data-disclosure-toggle]').forEach(function(toggle) {
    toggle.addEventListener('click', function(event) {
      event.preventDefault();
      const disclosure = this.closest('.disclosure');
      const expanded = disclosure.getAttribute('aria-expanded') === 'true' || false;
      disclosure.setAttribute('aria-expanded', !expanded);
    });
  });

  // Select options
  document.querySelectorAll('[data-disclosure-option]').forEach(function(option) {
    option.addEventListener('click', function(event) {
      event.preventDefault();
      const value = this.getAttribute('data-value');
      const input = this.closest('.disclosure').querySelector('[data-disclosure-input]');
      input.value = value;
      this.closest('form').submit();
    });
  });
});
